import { Component } from '@angular/core';
import { Documento } from 'src/app/shared/interfaces/custom/documento';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import { ShopService } from 'src/app/shared/api/shop.service';
import { StoreService } from 'src/app/shared/services/store.service';
import { Destinazione } from 'src/app/shared/interfaces/custom/destinazione';
import { AccountService } from 'src/app/shared/services/custom/account.service';
import { dataConsegnaDocumentoToISOString, formatDate, formatDateRitiro } from 'src/app/shared/helpers/formatDate';
import { convertPropertyBinding } from '@angular/compiler/src/compiler_util/expression_converter';
import { getTipoSpedizioneStr } from 'src/app/shared/interfaces/custom/spedizione';
import { RootService } from 'src/app/shared/services/root.service';

@Component({
     selector: 'app-restaurantordersuccess',
  templateUrl: './restaurantordersuccess.component.html',
  styleUrls: ['./restaurantordersuccess.component.scss']
})
export class RestaurantordersuccessComponent {
    ordine: Documento;
    condDiPagamento;
    articoliConOpzioni;

    destinazione : Destinazione;
    cliente : any;

    consegnaInfo;

    constructor(
        public root: RootService,
        private location: Location,
        private shop : ShopService,
        public store : StoreService,
        private account : AccountService
    ) {
        this.isB2B = this.store.price == 'b2b';
    }

    isB2B;

    ngOnInit() {
        try {
            let lastOrder = localStorage.getItem('lastOrder');
            this.ordine = JSON.parse(lastOrder);

            if (this.ordine.dataDocumento) {
                this.ordine.dataDocumento = this.ordine.dataDocumento.slice(0, 10);
            }
            else {
                this.ordine.dataDocumento = this.ordine.data_documento.slice(0, 10);
            }

            this.shop.getArticoliDiOrdine(this.ordine).subscribe(r => {
                this.articoliConOpzioni = r;
            });

            this.shop.getCondizioniDiPagamento().subscribe(r => {
                let codice = this.ordine.condizioneDiPagamento;
                let found = r.find(obj => obj.codice == codice);
                if (found)
                    this.condDiPagamento = found.descrizione;
                else
                    this.condDiPagamento = codice;
            });

            this.account.getOrder(this.ordine.numreg, {}).subscribe(r => {
                this.cliente = r['extra_cliente'];
                this.destinazione = r['extra_destinazione'];
    
                this.consegnaInfo = {
                    tipo_spedizione: r.tipo_spedizione,
                }

                if (r.dataConsegna) {
                    this.consegnaInfo['dataConsegna'] = r.dataConsegna;
                }

                if (new Date(r.data_ritiro) > new Date(2020, 0, 1))
                    this.consegnaInfo['data_ritiro'] = r['data_ritiro'];
    
            });

        } catch (err) {
            this.location.back();
        }
    }

    formatDate = formatDate;
    formatDateRitiro = formatDateRitiro;

    getModalitaDiSpedizione(modalita) {
        return getTipoSpedizioneStr(modalita);
    }

    getOptionLine(option, articolo) {
        const option_list = (i) => "option_list" + i;
        const option_code = (i) => "option_code" + i;
        const optionlist = (i) => "optionlist" + i;
        const option_disponibili = (i) => "option_disponibili_" + i;
        let line = [];
        for (let i = 1; i <= 4; i++) {
          if (option[option_list(i)]) {
            let str = "";
            let list = articolo[optionlist(i)];
            str += list ? list.descrizione : option[option_list(i)]
            str += ": ";
            let optionObj = articolo[option_disponibili(i)].find(obj => obj.progressivo == option[option_code(i)]);
            str += optionObj ? optionObj.codice : option[option_code(i)];
            line.push(str);
          }
        }
    
    
        return "- " + line.join(', ');
      }

    getRighePrincipali() {
        return this.ordine.corpo.filter(riga => {
            if (riga.tipoRiga == 4 || riga.tipoRiga == 3 || (riga.tipoRiga != 0 && !riga.tipoRiga))
                return true;
            if (riga.tipoRiga == 0 || riga.tipoRiga == 2) {
                if (!riga.riferimentoInternoDocumento)
                    return true;
                else if (riga.riferimentoInternoDocumento.endsWith('ART'))
                    return true;
                return false;
            }
            return false;
        });
    }

    getComponibili(riferimento) {
        if (!riferimento)
            return null;

        let ref_num = riferimento.split('-')[0];
        return this.ordine.corpo.filter(riga => {
            let rigaRef = riga.riferimentoInternoDocumento;
            if (!rigaRef)
                return false;

            if (rigaRef.startsWith(ref_num + '-') && rigaRef.endsWith('COMP'))
                return true;
        });
    }

    getComponibiliTextArrray(riferimento) {
        if (!riferimento)
            return null;
        return this.getComponibili(riferimento).map(riga => riga.qta + ' × ' + riga.descrizioneArticolo);
    }

    getAttributi(riferimento) {
        if (!riferimento)
            return null;

        let ref_num = riferimento.split('-')[0];
        return this.ordine.corpo.filter(riga => {
            let rigaRef = riga.riferimentoInternoDocumento;
            if (!rigaRef)
                return false;

            if (rigaRef.startsWith(ref_num + '-') && rigaRef.endsWith('ATTR'))
                return true;
        })
    }

    getAttributiTextArray(riferimento) {
        if (!riferimento)
            return null;
        return this.getAttributi(riferimento).map(riga => riga.descrizioneArticolo);
    }

    getTotaleRiga(item, senzaIva) {
        let riferimento = item.riferimentoInternoDocumento;

        let getTotal = (riga) => senzaIva ? riga.totale_riga - riga.iva_riga : riga.totale_riga;

        if (!riferimento) {
            return getTotal(item);
        }

        let totaleAttributi = 0;
        this.getAttributi(riferimento).forEach(attr => {
            if (attr.tipoRiga != 2)
                totaleAttributi += getTotal(attr);
        });

        let totalArticoloComponibili = 0;
        if (item.tipoRiga == 2) {
            this.getComponibili(riferimento).forEach(comp => {
                totalArticoloComponibili += getTotal(comp);
            });
        }
        else {
            totalArticoloComponibili = getTotal(item);
        }

        return totaleAttributi + totalArticoloComponibili;
        
    }

    qta_riga(riga) {
        // if (riga.descrizioneArticolo.startsWith('[CONF.')) {
        //     try {
        //         const rx = / da (\d+) pz\.]/;
        //         let conf_pz = Number(rx.exec(riga.descrizioneArticolo)[1]);
        //         return riga.qta / conf_pz;
        //     } catch (err) {
        //         return riga.qta;
        //     }
        // }
        
        return riga.qta;
    }

    isDataConsegnaRitiroValida(data) {
        return data && !data.startsWith('1990');
    }

}
